import React from "react";
import { Button, message, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useReportBillModel } from "../reportBillModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, setDispatchVisible, exportMaintenance } = useReportBillModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "4-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            {
                id: selectedRow.maintenanceCode as string, mode: "look", parentInfo: { selectedNavId }
            },
            true
        );
    }

    const onDispatchLook = () => {
        if (selectedRowKeys.length !== 1) {
            message.warning({ content: "请选择一条数据进行查看！", key: "warning" });
        } else {
            setDispatchVisible(true)
        }

    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.VRM2_REPORTREPAIRS_DETIAL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onDispatchLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_REPORTREPAIRS_EXPORT}>
            <Button
                // disabled={true}
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportMaintenance().then()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        // <YhBox title="历史工单" action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}